export const endPoints = {
  GET_DATA_FROM_SKY_KIT: "get-data-from-sky-kit",
  GET_CLOSING_QUESTIONER: "get-closing-questioner",
};
